import { render, staticRenderFns } from "./SideNavWithFilters.vue?vue&type=template&id=54cc115e&scoped=true"
import script from "./SideNavWithFilters.vue?vue&type=script&lang=js"
export * from "./SideNavWithFilters.vue?vue&type=script&lang=js"
import style0 from "./SideNavWithFilters.vue?vue&type=style&index=0&id=54cc115e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cc115e",
  null
  
)

export default component.exports